import {BASE_TRACK_API_URL} from "@constants/config";
import {serialize} from "@helpers/query/serialize";
import {apiRequest} from "@helpers/query/apiRequest";
import {IAuthenticateBody, ITokensData} from "@containers/auth/types/auth";
import {getCookie} from "@helpers/cookie/cookie";
import {getSiteRegion} from "@helpers/appSettings/appSettings";

export const refreshToken = async () => {
    return await apiRequest<ITokensData>({
        url: `${BASE_TRACK_API_URL}/v1/authenticate/refresh?` + serialize({refreshToken: getCookie('refreshToken')}),
        options: {
            method: "GET",
        },
    });

}


export const authenticateDemo = async (): Promise<ITokensData> => {
    const region = getSiteRegion()

    return await apiRequest<ITokensData>({
        url: `${BASE_TRACK_API_URL}/v1/authenticate/demo` + (region ? '?' + serialize({region}) : ''),
        options: {
            method: "POST",
        }
    });
}

export const authenticate = async (body: IAuthenticateBody): Promise<ITokensData> => {
    const url = `${BASE_TRACK_API_URL}/v1/authenticate?`

    return await apiRequest<ITokensData>({
        url,
        options: {
            method: "POST",
            body: JSON.stringify({region: getSiteRegion(), ...body}),
            headers: {
                'Content-Type': 'application/json',
            },
        }
    });
}
